var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApFireShuttersCurtainsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3 -3.93)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 5.93)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.034,10.5h4.345A.621.621,0,0,0,39,9.878V6.551a.621.621,0,0,0-.621-.621H3.621A.621.621,0,0,0,3,6.551V9.878a.621.621,0,0,0,.621.621H7.966v3.544H4.93L5.961,12.8A.621.621,0,0,0,5,12.019L3.143,14.291a.621.621,0,0,0,.478.993H7.966V18.8H4.93l1.03-1.241A.621.621,0,1,0,5,16.773L3.143,19.008a.621.621,0,0,0,.478,1H7.966V23.52H4.93l1.03-1.241A.619.619,0,1,0,5,21.491L3.143,23.762a.621.621,0,0,0,.478,1H7.966v3.513H4.93l1.03-1.241A.619.619,0,1,0,5,26.245L3.143,28.517a.621.621,0,0,0,.478,1H32.793V33.24a2.563,2.563,0,1,0,1.241,0V29.516h4.345a.621.621,0,0,0,.478-1.012L37,26.233a.619.619,0,0,0-.956.788l1.03,1.241H34.034v-3.5h4.345a.621.621,0,0,0,.478-1.012L37,21.478a.619.619,0,0,0-.956.788l1.03,1.241H34.034v-3.5h4.345a.621.621,0,0,0,.478-1L37,16.736a.621.621,0,0,0-.956.782l1.03,1.241H34.034V15.284h4.345a.621.621,0,0,0,.478-1.012L37,12a.621.621,0,1,0-.956.782l1.03,1.241H34.034Zm.7,25.225A1.322,1.322,0,1,1,33.414,34.4h0A1.328,1.328,0,0,1,34.736,35.723ZM4.241,7.171H37.759V9.257H4.241ZM9.207,10.5H32.793v3.544H9.207ZM32.793,28.275H9.207V24.762H32.793Zm0-4.754H9.207V20.007H32.793Zm0-4.754H9.207V15.284H32.793Z",
    transform: "translate(-3 -5.93)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApFireShuttersCurtainsIcon);
export default __webpack_public_path__ + "static/media/ap-fire-shutters-curtains-icon.29b60cc4e9e48fcb0854a78ce0530b09.svg";
export { ForwardRef as ReactComponent };